const permissions = {
  unauthorized: {
    title: "Unauthorized access",
    description:
      "You don't have the permissions required to view this page or perform this action. Contact your system administrator to request the required permissions.",
    goHome: "Back to home",
  },
};

export default permissions;
